"use client";
import { css as r } from "@emotion/react";
const t = (e) => {
  const o = e ? `overflow-${e}` : "overflow";
  return r`
		${o}: hidden;

		text-overflow: ellipsis;
		white-space: nowrap;
	`;
};
export {
  t as ellipsis
};
